import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffSettings = () => import('./staff/settings')
const ViewStaffAccountPlan = () => import('./staff/accountPlan')
const ViewStaffAccountingEntries = () => import('./staff/accountingEntries')
const ViewStaffAccountingLedger = () => import('./staff/accountingLedger')
const ViewStaffAccountingClosing = () => import('./staff/accountingClosing')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'AccountingStaffDashboard',
  settings: 'AccountingStaffSettings',
  accountPlan: 'AccountingStaffAccountPlan',
  accountingEntries: 'AccountingStaffAccountingEntries',
  accountingLedger: 'AccountingStaffAccountingLedger',
  accountingClosing: 'AccountingStaffAccountingClosing',
}

const router =
  [
    {
      path: '/st/accounting',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Contabilidad',
          }                                  
        },    
        {
          path: 'settings',
          name: VIEWS.settings,
          component: ViewStaffSettings,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuracion contabilidad',
          }                                  
        },  
        {
          path: 'account-plan',
          name: VIEWS.accountPlan,
          component: ViewStaffAccountPlan,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Plan de cuentas',
          }                                  
        },                                
        {
          path: 'accounting-entries',
          name: VIEWS.accountingEntries,
          component: ViewStaffAccountingEntries,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Asientos contables',
          }                                  
        },
        {
          path: 'accounting-ledger',
          name: VIEWS.accountingLedger,
          component: ViewStaffAccountingLedger,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Mayor de cuentas',
          }
        },
        {
          path: 'accounting-closing',
          name: VIEWS.accountingClosing,
          component: ViewStaffAccountingClosing,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cierre y apertura de ejercicio',
          }
        },
      ]
    },

    {
      path: '/cu/accounting',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/accounting',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
